import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { isIframe } from 'services/iframe'
import { extractQueryParams } from 'services/url'

/**
 * This hook will return true if the current page is being rendered in an iframe.
 * It will also return true if the iframe query param is set to true. (to force iframe mode)
 * Note that this hook is set up to avoid SSR mismatches so it might not render the correct value on the first render.
 */
function useIsIframe() {
  const router = useRouter()
  const forceIframe = extractQueryParams(router.asPath).iframe === 'true'
  const isIframeNow = isIframe()
  // We are forced to set the initial value to false to avoid SSR mismatches
  const [isIframeState, setIsIframeState] = useState<boolean>(false)

  useEffect(() => {
    setIsIframeState(isIframeNow || forceIframe)
  }, [isIframeNow, forceIframe])

  return isIframeState
}

export default useIsIframe
